// Deduped tap-to-add email contacts for a supplier: main email, sales rep and
// any named team contacts saved on the supplier record.
export const supplierContacts = (supplier) => {
  if (!supplier) return [];
  const seen = new Set();
  const out = [];
  const add = (email, label) => {
    const e = (email || "").trim().toLowerCase();
    if (!e || !e.includes("@") || seen.has(e)) return;
    seen.add(e);
    out.push({ email: String(email).trim(), label });
  };
  add(supplier.email, supplier.name || "Supplier");
  add(supplier.rep_email, supplier.rep_name ? `Rep · ${supplier.rep_name}` : "Sales rep");
  (supplier.contacts || []).forEach((c) => add(c.email, c.name || c.role || "Contact"));
  return out;
};
